<form [formGroup]="criarMarcaForm">
  <h1 mat-dialog-title>Criar nova marca</h1>
  <div mat-dialog-content>
    <app-campo
      [formulario]="criarMarcaForm"
      classe="horizontal-100"
      nomeControle="nome"
      descricao="Nova Marca"
      autoPreenchimento="off"
      (keyup.enter)="salvarNovaMarca()"
    ></app-campo>
  </div>
  <div mat-dialog-actions>
    <button type="button" class="btn btn-link" (click)="salvarNovaMarca()">
      {{loading ? 'Salvando' : ('salvar' | transloco)}} <span *ngIf="loading"><i class="fa-solid fa-spinner fa-spin-pulse fa-spin-reverse"></i></span>
    </button>
  </div>
</form>